import React from 'react';

import { WorkerPickerRow } from '@vyce/core/src/components/WorkerPickerRow';
import { CompanyWorkerItem } from '@vyce/core/src/types';

interface Props {
  worker: CompanyWorkerItem;
  checked: boolean;
  onToggle: () => void;
}

// A form is delivered by email or SMS, so a worker with neither cannot be a recipient
export const FormExistingMemberRow: React.FC<Props> = ({ worker, checked, onToggle }) => {
  const disabled = !worker.email && !worker.phone;

  return (
    <WorkerPickerRow
      worker={worker}
      checked={checked}
      onToggle={onToggle}
      disabled={disabled}
      disabledTooltip="No contact details"
    />
  );
};
